/** Public Spanish paths (SEO URL map). Use these in links, routes, sitemap, and canonicals. */
export const PATHS = {
  services: "/servicios",
  about: "/sobre-nosotros",
  faq: "/preguntas-frecuentes",
  privacy: "/politica-de-privacidad",
  terms: "/terminos-de-uso",
  textMessage: "/politica-de-mensajes",
  signup: "/registro",
  signupWorker: "/registro/worker",
  signupCustomer: "/registro/customer",
  login: "/ingresar",
  workerPrefix: "/profesional",
  servicePrefix: "/service",
} as const;

export function workerPath(slug: string): string {
  return `${PATHS.workerPrefix}/${slug}`;
}

export function servicePath(slug: string): string {
  return `${PATHS.servicePrefix}/${slug}`;
}

export function isWorkerPath(pathname: string): boolean {
  return pathname === PATHS.workerPrefix || pathname.startsWith(`${PATHS.workerPrefix}/`);
}

export function isServicePath(pathname: string): boolean {
  return pathname === PATHS.servicePrefix || pathname.startsWith(`${PATHS.servicePrefix}/`);
}
